import React, { useState, useEffect } from 'react'
import { Query, Mutation } from 'react-apollo'
import { useQuery, useMutation } from '@apollo/react-hooks'
import _ from 'lodash'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { CREATE_TIRE_PATCH_SHOP, UPDATE_TIRE_PATCH_SHOP } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { GET_TIRE_PATCH_SHOP } from '../../../constants/graphql/query'
import { ActionBar } from '../../../components/tire-patch-shop-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState({})

  const { data, error, loading } = useQuery(GET_TIRE_PATCH_SHOP, { skip: isAddMode, variables: { id: props.match.params.id } })
  const [doAction, { loading: mutationLoading }] = useMutation(isAddMode ? CREATE_TIRE_PATCH_SHOP : UPDATE_TIRE_PATCH_SHOP)

  const onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: value,
    })
  }

  useEffect(() => {
    if (!isAddMode && !loading) {
      setMutationVariables({
        name: data.TirePatchStoreInfo.name,
        phoneNumber: data.TirePatchStoreInfo.phoneNumber,
        ...mutationVariables,
      })
    }
  }, [loading])

  if (!isAddMode && loading && _.isEmpty(data)) return <Loading center='true' />
  if (!isAddMode && error) return <P>เกิดข้อผิดพลาด</P>

  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, onChangeHandler)
          : <Div>
            {
              detailType(props.match.params, onChangeHandler, data.TirePatchStoreInfo) // argument mode
            }
          </Div>
      }
      {/* ================== Footer section ================== */}
      <ActionBar
        loading={mutationLoading}
        disabled={_.isUndefined(mutationVariables.name) || _.isEmpty(mutationVariables.name)
          || _.isUndefined(mutationVariables.phoneNumber) || _.isEmpty(mutationVariables.phoneNumber)}
        isAddMode={isAddMode}
        isViewMode={isViewMode}
        doAction={doAction}
        mutationVariables={{ ...mutationVariables }}
        props={props}
      />
    </Div>
  )
}

export default Index
export { Index }
